module.exports = __webpack_public_path__ + "static/media/card-JCB.b0fba471.svg";